import React from 'react';
import { connect } from 'react-redux';
import DataTable from '@/components/DataTable/DataTable';
import { getPortfolioAction } from '@/actions/trading';
import { dataType } from '@/constants/data-type';
import classnames from 'classnames';
import { getSafe } from '@/helpers/global';
import { Comparator, utilsFunction, formatFunctions, writeFileFunctions, Converter} from '@/helpers/functions';
import { PARAMS as requestParams } from '@/constants/params';
import TabHeader from '@/components/TabHeader/TabHeader';
import { CUSTOM_STYLES } from '@/constants/app';
import Dropdown from '@/components/Dropdown/Dropdown';
import BlockControl from '@/components/BlockControl/BlockControl';
import { iTradeEnv } from '@/configurations/app-configs/iTrade.env'
import { stockActions } from '@/actions/trading/stock.action';
import ExportIconDark from '@/assets/images/icons/light/export_icon_dark.png';
import ExportIconLight from '@/assets/images/icons/light/export_icon_light.png';
import { appConfigConstants } from '@/configurations/app-configs/app.config.constants';
import { WS_LANG_KEY } from '@/constants/app';
import { ACTION_TYPE } from "@/constants/w-socket";
import { TABLE_CONFIGURABLE_KEYS } from '@/constants/preference';
import '@/assets/styles/commons/_styles.scss'


const icons = {
  exportIcon: {
    dark: ExportIconDark,
    light: ExportIconLight
  }
}

class Portfolio extends React.Component {
  constructor(props) {
    super(props);
    this.defaultColumnDefs = () => [{
      headerName: this.props.language.common_symbol,
      colId: 'common_symbol',
      field: 'symbol',
      tooltipField: 'symbol',
      headerClass: 'table-header',
      cellClass: 'table-cell',
      dataType: dataType.SYMBOL,
      minWidth: 120,
      maxWidth: 230
      // cellRendererParams: {
      //   action:  this.toQuotePage.bind(this)
      // }
    },
    {
      headerName: this.props.language.common_name,
      colId: 'common_name',
      field: 'stockName',
      tooltipField: 'stockName',
      headerClass: 'table-header',
      cellClass: 'table-cell table-ellipsis',
      dataType: dataType.TEXT,
      minWidth: 380,
    },
    {
      headerName: this.props.language.common_price,
      colId: 'common_price',
      field: 'price',
      tooltipField: 'price',
      headerClass: 'table-header text-end',
      cellClass: 'table-cell',
      dataType: dataType.CURRENCY,
      comparator: Comparator.numberComparator,
      minWidth: 67,
      maxWidth:100
      // cellRendererParams: {
      //   action:  this.openPlaceorder.bind(this)
      // }
    },
    {
      headerName: this.props.language.common_change,
      colId: 'common_change',
      field: 'change',
      tooltipField: 'change',
      headerClass: 'table-header text-end',
      cellClass: 'table-cell text-end',
      bindingColor: true,
      dataType: dataType.CURRENCY,
      comparator: Comparator.numberComparator,
      minWidth:142,
      maxWidth:200
    },
    {
      headerName: this.props.language.common_bid,
      colId: 'common_bid',
      field: 'bid',
      tooltipField: 'bid',
      headerClass: 'table-header text-end',
      cellClass: 'table-cell text-end',
      dataType: dataType.CURRENCY,
      comparator: Comparator.numberComparator,
      minWidth:60,
      maxWidth:100
    },
    {
      headerName: this.props.language.common_ask,
      colId: 'common_ask',
      field: 'ask',
      tooltipField: 'ask',
      headerClass: 'table-header text-end',
      cellClass: 'table-cell text-end',
      dataType: dataType.CURRENCY,
      comparator: Comparator.numberComparator,
      minWidth:60,
      maxWidth:100
    },
    {
      headerName: this.props.language.common_position,
      colId: 'common_position',
      field: 'position',
      tooltipField: 'position',
      headerClass: 'table-header text-end',
      cellClass: 'table-cell cell-action',
      dataType: dataType.NUMBER,
      comparator: Comparator.numberComparator,
      minWidth: 80,
      maxWidth:150
    },
    {
      headerName: this.props.language.common_tradable_quantity,
      colId: 'common_tradable_quantity',
      field: 'tradableq',
      tooltipField: 'tradableq',
      headerClass: 'table-header text-end',
      cellClass: 'table-cell text-end',
      dataType: dataType.NUMBER,
      comparator: Comparator.numberComparator,
      minWidth: 114,
      maxWidth:180
    },
    {
      headerName: this.props.language.common_average_cost,
      colId: 'common_average_cost',
      field: 'cost',
      tooltipField: 'cost',
      headerClass: 'table-header text-end',
      cellClass: 'table-cell text-end',
      dataType: dataType.AVG_PRICE,
      comparator: Comparator.numberComparator,
      minWidth: 114,
      maxWidth:180
    },
    {
      headerName: this.props.language.common_market_value,
      colId: 'common_market_value',
      field: 'marketv',
      tooltipField: 'marketv',
      headerClass: 'table-header text-end',
      cellClass: 'table-cell cell-action',
      dataType: dataType.CASH,
      comparator: Comparator.numberComparator,
      minWidth: 100,
      maxWidth:180
    },
    {
      headerName: this.props.language.common_today_PL,
      colId: 'common_today_PL',
      field: 'todayPL',
      tooltipField: 'todayPL',
      headerClass: 'table-header text-end',
      cellClass: 'table-cell cell-action',
      dataType: dataType.PERCENT_BASED,
      bindingColor: true,
      comparator: Comparator.numberComparator,
      minWidth: 150,
    },
    {
      headerName: this.props.language.common_PL_percent,
      colId: 'common_PL_percent',
      field: 'pl',
      tooltipField: 'field',
      headerClass: 'table-header text-end',
      cellClass: 'table-cell cell-action',
      dataType: dataType.PERCENT_BASED,
      bindingColor: true,
      comparator: Comparator.numberComparator,
      minWidth: 200,
      maxWidth:300
    },
    {
      headerName: this.props.language.common_ccy,
      colId: 'common_ccy',
      field: 'currencyID',
      tooltipField: 'currencyID',
      headerClass: 'table-header',
      cellClass: 'table-cell cell-action',
      dataType: dataType.TEXT,
      minWidth: 60,
      maxWidth:100
    },
    {
      headerName: this.props.language.common_today_turnover,
      colId: 'common_today_turnover',
      field: 'todayturnover',
      tooltipField: 'todayturnover',
      headerClass: 'table-header text-end',
      cellClass: 'table-cell cell-action',
      dataType: dataType.CASH,
      comparator: Comparator.numberComparator,
      minWidth: 180,
      maxWidth:260
    },
    {
      headerName: this.props.language.common_today_purchase_price,
      colId: 'common_today_purchase_price',
      field: 'todaypurchase',
      tooltipField: 'todaypurchase',
      headerClass: 'table-header text-end',
      cellClass: 'table-cell cell-action',
      dataType: dataType.CURRENCY,
      comparator: Comparator.numberComparator,
      minWidth: 120,
      maxWidth:200
    },
    {
      headerName: this.props.language.common_today_sales_price,
      colId: 'common_today_sales_price',
      field: 'todaysales',
      tooltipField: 'todaysales',
      headerClass: 'table-header text-end',
      cellClass: 'table-cell cell-action',
      dataType: dataType.CURRENCY,
      comparator: Comparator.numberComparator,
      minWidth: 120,
      maxWidth:200
    }]
    this.fundColumnDefs = () => [
      {
        headerName: this.props.language.funds_market_id,
        colId: 'funds_market_id',
        field: 'marketID',
        tooltipField: 'marketID',
        headerClass: 'table-header',
        cellClass: 'table-cell',
        dataType: dataType.SYMBOL,
        minWidth: 80,
        maxWidth:120
      },
      {
        headerName: this.props.language.funds_instrument_id,
        colId: 'funds_instrument_id',
        field: 'stockCode',
        tooltipField: 'tooltipField',
        headerClass: 'table-header',
        cellClass: 'table-cell',
        dataType: dataType.SYMBOL,
        minWidth: 160,
        maxWidth: 230
      },
      // {
      //   headerName: this.props.language.funds_instrument_id,
      //   colId: 'funds_instrument_id',
      //   field: 'symbol',
      //   headerClass: 'table-header',
      //   cellClass: 'table-cell',
      //   dataType: dataType.SYMBOL,
      //   cellRendererParams: {},
      //   minWidth: 160,
      //   maxWidth: 230
      // },
      {
        headerName: this.props.language.funds_instrument_name,
        colId: 'funds_instrument_name',
        field: 'stockName',
        tooltipField:'stockName',
        headerClass: 'table-header',
        cellClass: 'table-cell table-ellipsis',
        dataType: dataType.TEXT,
        cellRendererParams: {
          cellClass: 'table-cell table-ellipsis'
        },
        minWidth:380,
      },
      {
        headerName: this.props.language.funds_tradable_qty,
        colId: 'funds_tradable_qty',
        field: 'tradableQty',
        tooltipField: 'tradableQty',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell text-right',
        dataType: dataType.FUNDS_QUANTITY,
        cellRendererParams: {},
        minWidth: 130,
        maxWidth: 170
      },
      {
        headerName: this.props.language.funds_position,
        colId: 'funds_position',
        field: 'position',
        tooltipField: 'position',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell text-right',
        dataType: dataType.FUNDS_QUANTITY,
        cellRendererParams: {},
        minWidth: 80,
        maxWidth: 100
      },
      {
        headerName: this.props.language.funds_price,
        colId: 'funds_price',
        field: 'refPrice',
        tooltipField: 'refPrice',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell text-right',
        dataType: dataType.STOP_PRICE,
        cellRendererParams: {},
        minWidth: 100,
        maxWidth:120
      },
      {
        headerName: this.props.language.funds_today_PL,
        colId: 'funds_today_PL',
        field: 'todayPL',
        tooltipField: 'todayPL',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell text-end',
        bindingColor: true,
        dataType: dataType.PERCENT_BASED,
        cellRendererParams: {},
        minWidth: 150,
      },
      {
        headerName: this.props.language.funds_PL_percent,
        colId: 'funds_PL_percent',
        field: 'pl',
        tooltipField: 'pl',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell text-end',
        bindingColor: true,
        dataType: dataType.PERCENT_BASED,
        cellRendererParams: {},
        minWidth: 200,
        maxWidth:300
      },
      {
        headerName: this.props.language.funds_ccy,
        colId: 'funds_ccy',
        field: 'currencyID',
        tooltipField: 'currencyID',
        headerClass: 'table-header',
        cellClass: 'table-cell',
        dataType: dataType.TEXT,
        cellRendererParams: {},
        minWidth: 60,
        maxWidth:100
      },
      {
        headerName: this.props.language.funds_average_price,
        colId: 'funds_average_price',
        field: 'totalAverageCost',
        tooltipField: 'totalAverageCost',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell text-end',
        dataType: dataType.AVG_PRICE,
        cellRendererParams: {},
        minWidth: 100,
        maxWidth:120
      },
      {
        headerName: this.props.language.funds_market_value,
        colId: 'funds_market_value',
        field: 'marketv',
        tooltipField: 'marketv',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell text-end',
        dataType: dataType.CASH,
        cellRendererParams: {},
        minWidth: 100,
        maxWidth:180
      },
    ]
    this.state = {
      columnDefs: this.defaultColumnDefs(),
      data: null,
      portfolio: [{
        id: '1', title: 'portfolio_title', isActive: false
      }],
      totalMarket: '',
      totalFloatingPL: '',
      totalFloatingPLPercent: '',
      marketCode: '',
      productList:[
        {id: '1', title: 'market_all', value:'', isActive: true},
        {id: '2', title: 'market_hkex', value:'HKEX', isActive: false},
        {id: '3', title: 'market_usex', value:'USEX', isActive: false},
        {id: '4', title: 'market_stock_connect', value:'MAMK', isActive: false},
        {id: '5', title: 'common_funds', value:'FUND', isActive: false}
      ]
    }
    props.innerRef(this);
  }

  // handleChangeMarket = (market) => {
  //   const marketCode = market ? market.value : '';
  //   // if (marketCode) {
  //     this.setState({
  //       marketCode
  //     }, () => {
  //       this.getPortfolio()
  //     })
  //   // }
  // }

  onChangeproductList=(e)=>{
    const currentMarketCode = this.state.productList[e].value
    this.state.productList.map((item,index)=>{
      if(e === index){
        item.isActive = true
      }else{
        item.isActive = false
      }
      return item
    })
    this.setState({
      marketCode: currentMarketCode,
      productList:this.state.productList,
      columnDefs: currentMarketCode === 'FUND' ? this.fundColumnDefs() : this.defaultColumnDefs()
    },()=>{
      this.getPortfolio()
    })
  }
  handExportExcelClick = () => {
    const { columnDefs, data } = this.state
    writeFileFunctions.writeExeclFile({ columnDefs, data, fileName: 'Portfolio.xlsx' })
  }

  getPortfolio = () => {
    const { user, currentTradingAccount, language , mdsToken} = this.props
    const { marketCode } = this.state
    const { clientID,tradingAccSeq } = currentTradingAccount
    if (marketCode == undefined) return
    const params = {
      [requestParams.CLIENT_ID]: clientID,
      [requestParams.TRADING_ACCOUNT_ID]: clientID,
      [requestParams.LANGUAGE]: language.lang,
      [requestParams.MARKET_ID]: marketCode === 'MAMK' ? '' : marketCode,
      [requestParams.TRADING_ACC_SEQ]: tradingAccSeq
    }
    this.portfolioRef.toggleLoadingOverlay(true);
    this.setState({data : [] , isrefresh : true})
    this.props.getAccountPortfolio(params, res => {
      if (Array.isArray(res.portfoliosList) && res.portfoliosList.length) {
        const lang = this.props.language.lang
        const sample = ['symbol', 'stockName', 'price', 'change','bid' ,'ask', 'position','marketv','todayPL','pl','currencyID','todayturnover', 'todaypurchase' , 'todaysales'].reduce((prev, next) => (prev[next] = '-', prev), {})
        let filted = []

        if (this.state.marketCode) {
          filted = res.portfoliosList.filter(item => {
            if (this.state.marketCode === 'MAMK' || this.state.marketCode === 'SZMK') {
              return item.marketID === 'MAMK' || item.marketID === 'SZMK'
            } else {
              return item.marketID === this.state.marketCode
            }
          })
        } else {
          filted = res.portfoliosList
        }

        const data = []

        for (let i = 0; i <  filted.length; i++) {
          const item = filted[i]
          const deepSample = JSON.parse(JSON.stringify(sample))
          deepSample.symbol = [item.marketID, item.stockCode].join('.')
          deepSample.marketID = item.marketID
          deepSample.stockCode = item.stockCode
          deepSample.position= item.ledgerQty
          deepSample.tradableQty = item.tradableQty
          deepSample.refPrice = item.refPrice
          deepSample.totalAverageCost = item.totalAverageCost
          deepSample.pl = `${formatFunctions.dataFormat(item.floatingPL, dataType.CASH)} (${utilsFunction.datatableFormatPercent(item.floatingPLPercent)})`  
          deepSample.todayPL = `${formatFunctions.dataFormat(item.todayFloatingPL, dataType.CASH)} (${utilsFunction.datatableFormatPercent(item.todayFloatingPLPercent)})`  
          deepSample.marketv = item.marketValue
          deepSample.currencyID = item.currencyID
          deepSample.todaypurchase = item.ttodayConfirmBuy
          deepSample.todaysales = item.ttodayConfirmSell
          deepSample.tradableq = item.tradableQty
          deepSample.cost = item.totalAverageCost
          if(item.marketID === 'FUND') {
            deepSample.price = item.refPrice
          }
          if (lang === 'zh_TW' || lang === 'zh_CN') {
            deepSample.stockName = item.stockChineseShortName
            if(!item.stockChineseShortName){
              deepSample.stockName = item.stockName
            }
          } else {
            deepSample.stockName = item.stockName
          }
          if(mdsToken){
            let stockID = item.stockCode.split('').findIndex(i => i !== '0')
            if (stockID > -1) stockID = item.stockCode.substr(stockID)
            const marketID = Converter.mappingWebSocketMarket(item.marketID)
            // const dparams = { instrumentID: item.stockCode, exchangeID: item.marketID }
            if (item.marketID === 'USEX') {
              const params = { symbols: [{ exchangeID: marketID, key: stockID }] }
              stockActions.getBestBidBestAskAction(params, bestBidBestAskRes => {
                const oneNewRowData = JSON.parse(JSON.stringify(this.state.data))
                const deepSample = oneNewRowData?.[i]
                if (deepSample) {
                  deepSample.bid = Array.isArray(bestBidBestAskRes.bestBid) ? bestBidBestAskRes.bestBid?.[0]?.price : bestBidBestAskRes.bestBid?.price
                  deepSample.ask = Array.isArray(bestBidBestAskRes.bestAsk) ? bestBidBestAskRes.bestAsk?.[0]?.price : bestBidBestAskRes.bestAsk?.price 
                  this.setState({ data: oneNewRowData })
                }
              })
              stockActions.getStatisticsAction(params, statisticsRes => {
                const twoNewRowData = JSON.parse(JSON.stringify(this.state.data))
                const deepSample = twoNewRowData?.[i]
                if (deepSample) {
                  if(marketID !=='FUND') {
                    deepSample.price = statisticsRes.last
                  }
                  stockActions.getClosingPriceAction(params, closingPriceRes => {
                    const threeNewRowData = JSON.parse(JSON.stringify(this.state.data))
                    const deepSample = threeNewRowData?.[i]
                    if (deepSample) {
                      deepSample.change = `${utilsFunction.datatableCurrencyFormatter(statisticsRes.last - closingPriceRes.closingPrice)} (${utilsFunction.datatableFormatPercent((statisticsRes.last - closingPriceRes.closingPrice) / closingPriceRes.closingPrice * 100)})`
                      this.setState({ data: threeNewRowData })
                    }
                  })
                  this.setState({ data: twoNewRowData })
                }
              })
            } else {
              const dparams = {
                symbols: [
                  {
                    exchangeID: marketID,
                    key: stockID
                  }
                ],
                sessID:mdsToken
              }
              const params = {
                msgType: ACTION_TYPE.SECURITY_FINANCIAL_DATA,
                symbol: { exchangeID: marketID, key: stockID },
                language: utilsFunction.switchToolTipsLanguage(this.props.language, WS_LANG_KEY.EN, WS_LANG_KEY.SC, WS_LANG_KEY.TC)
              }
              this.props.getFinancial(params, financialres => {
                if (financialres && Object.keys(financialres).length) {
                  const oneNewRowData = JSON.parse(JSON.stringify(this.state.data))
                  const deepSample = oneNewRowData?.[i]
                  if(deepSample){
                  this.props.getDetailPriceInfo(dparams, quetores => {
                    if (quetores.rtnCode) return
                    if (quetores && Object.keys(quetores).length) {
                      const twoNewRowData = JSON.parse(JSON.stringify(this.state.data))
                      const deepSample = twoNewRowData?.[i]
                      if (deepSample) {
                        deepSample.price = quetores.last
                        // deepSample.turnoverRate = quetores.turnoverRate ? quetores.turnoverRate : '-'
                        deepSample.bid = quetores.bids?.[0]?.price
                        deepSample.ask = quetores.asks?.[0]?.price
                        // deepSample.position = quetores.high
                        // deepSample.todayPL = quetores.low
                        deepSample.todayturnover = quetores.turnover
                        
                        deepSample.change = `${utilsFunction.datatableCurrencyFormatter(quetores.last - quetores.prev)} (${utilsFunction.datatableFormatPercent((quetores.last - quetores.prev) / quetores.prev * 100)})`
                        
                        // if (lang === 'zh_TW') {
                        //   deepSample.stockName = quetores.tcName
                        // } else if (lang === 'zh_CN') {
                        //   deepSample.stockName = quetores.scName
                        // } else {
                        //   deepSample.stockName = quetores.name
                        // }
                        this.setState({ data: twoNewRowData })
                      } 
                    }
                  })
                  this.setState({ data: oneNewRowData })
                }
                }
              })
            }
          }
          data.push(deepSample)
        }
        this.setState({ data })
      }
      this.setState({isrefresh:false})
      this.portfolioRef.toggleLoadingOverlay(false);
    })
  }

  componentDidMount() {
    const { currentTradingAccount, token, mdsToken } = this.props
    if (currentTradingAccount && token && mdsToken) {
      this.getPortfolio()
    }
  }

  componentDidUpdate(preProps) {
    const { currentTradingAccount, isNeedRefresh, language, mdsToken } = this.props
    if (JSON.stringify(preProps.currentTradingAccount) !=='{}' && preProps.currentTradingAccount !== currentTradingAccount) {
      this.getPortfolio()
    }
    if (isNeedRefresh && preProps.isNeedRefresh !== isNeedRefresh) {
      this.getPortfolio()
    }
    if (language && preProps.language !== language) {
      this.getPortfolio()
    }
    if(preProps.mdsToken != mdsToken && mdsToken){
      this.getPortfolio()
    }
  }

  componentWillUnmount() {
    this.setState = () => {
      return
    }
  }


  render() {
    const { language, isMobile, markets, isFilter, autoSize, tabHeader, theme } = this.props;
    const { data, columnDefs, portfolio, totalFloatingPLPercent, totalFloatingPL, productList } = this.state;
    return (
      <React.Fragment>
        <div className={classnames("section-table")}>
          {
            tabHeader && <TabHeader tabs={portfolio} refresh customStyle={CUSTOM_STYLES.HEADER_NORMAL} onRefresh={() => this.getPortfolio()}
            />
          }
          {
            isFilter && <div className={classnames("section-action-panel")}>
              {productList.map((item,index)=>{
                return  <span className={classnames('section-action-item', item.isActive && 'section-action-active')} key={index} onClick={()=>this.onChangeproductList(index)}>{language[item.title]}</span>
              })}
              {/* <span style={{marginLeft:'300px',color: theme === 'light' ? '#000' : ''}}>{getSafe(() => language.common_market)}:</span>
              <div className={classnames("section-action-box", "border-style")}>
                <Dropdown selectedOptions={[markets[0]]}
                  options={markets}
                  innerRef={(e) => this.marketRef = e}
                  onChange={(mrk) => this.handleChangeMarket(mrk[0])}
                >
                </Dropdown>
              </div> */}
              <BlockControl auth={appConfigConstants.exportExeclFile}>
                <div className="action-item export-file-wrapper">
                  <button className="export-excel-btn" onClick={this.handExportExcelClick}>
                    <img className="export-icon" src={icons.exportIcon[theme]} />
                    <span>{language.common_export_execl}</span>
                  </button>
                </div>
              </BlockControl>
            </div>
          }
          <DataTable
            name={TABLE_CONFIGURABLE_KEYS.MY_ACCOUNT_PORTFOLIO_ALL}
            columnDefs={columnDefs}
            data={data}
            innerRef={e => this.portfolioRef = e}
            // autoSizeColumns={autoSize}
          />
        </div>
      </React.Fragment>
    )
  }


  bindingColor(value) {
    if (value > 0) {
      return 'rise-color'
    } else if (value < 0) {
      return 'fall-color'
    } else {
      return ''
    }
  }
}

Portfolio.defaultProps = {
  isFilter: false,
  autoSize: true,
  tabHeader: true,
  innerRef: () => { },
}

export default connect(
  state => ({
    language: state.app.language,
    user: state.auth.user,
    currentTradingAccount: state.trade.currentTradingAccount,
    markets: [{ label: state.app.language.market_all, value: '' }, ...state.trade.markets],
    isNeedRefresh: state.refresh.orderTable,
    token: state.auth.token,
    theme: state.app.theme,
    mdsToken: state.trade.mdsToken,
    portfolios: state.trade.portfolios
  }),
  dispatch => ({
    getAccountPortfolio: (p, c) => dispatch(getPortfolioAction(p, c)),
    getDetailPriceInfo: (p, c) => dispatch(stockActions.getDetailPriceInfoAction(p, c)),
    getFinancial: (p, c) => stockActions.getFinancialAction(p, c),
  })
)(Portfolio)
